import React from 'react';
import { FacebookShareButton, PinterestShareButton } from 'react-share';
import PropTypes from 'prop-types';
import { LinkCopierContainer } from './LinkCopierContainer';

const HeaderCustom = ({
  HeaderMenuButton=null,
  HeaderLogo=null,
  HeaderLogoMark=null,
  articleHed=null,
  isMobile,
  social,
  isCeros,
  isSponsored,
  renderedSponsorLogo = null,
  setHeader,
  category,
  heroImage,
  tags,
  hedUrl,
  seo,
}) => {

  const { socialShareHeadline=null, facebookImage=null, facebookShareCopy=null, facebookImageAlt=null, pinterestImage=null, pinterestImageAlt=null, pinterestShareCopy=null } = social;
  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';

  const headerClassName = isCeros ? 'header-scrolling ceros' : 'header-scrolling custom-content';
  const headerContent2ndChildClass = isCeros ? 'header-content-ceros-child' : 'header-content';

  const renderedHeader =
  <div className={headerClassName}>
    <div className="header-contents">
      <div className="header-content">
        {HeaderMenuButton}
        {HeaderLogo}
        <div className="header-scrolling-article-hed" dangerouslySetInnerHTML={ { __html: articleHed } }></div>
      </div>
      {renderedSponsorLogo}
      <div className="header-content">
        <div className="btn-social-wrapper">
            <FacebookShareButton
              url={shareUrl}
              alt={facebookImageAlt}
              title={socialShareHeadline}
              description={facebookShareCopy}
              picture={facebookImage}
              className="btn-social btn-social__color--facebook social_click"
              onClick={() => analytics.track('Social Share', {action_type: 'facebook'})}>
              <span className="icon-facebook btn-social__icon"></span>
              <span className="btn-social__text">&nbsp;SHARE</span>
            </FacebookShareButton>
          </div>
          <div className="btn-social-wrapper">
            <PinterestShareButton
              url={shareUrl}
              alt={pinterestImageAlt}
              media={pinterestImage}
              description={seo.metaDescription}
              windowWidth={1000}
              windowHeight={730}
              className="btn-social btn-social__color--pinterest social_click"
              onClick={() => analytics.track('Social Share', {action_type: 'pinterest'})}>
              <span className="icon-pinterest btn-social__icon"></span>
              <span className="btn-social__text">&nbsp;PIN IT</span>
            </PinterestShareButton>
          </div>
      </div>
    </div>
  </div>;

  let cerosRenderedHeader;

  if (isMobile) {
    cerosRenderedHeader =
    <div className={headerClassName}>
    <div className="header-contents">
      <div className="header-content">
        {HeaderMenuButton}
        {HeaderLogoMark}
      </div>
      <div className="header-content-ceros-right">
        {renderedSponsorLogo}
        <div className="header-content">
          <LinkCopierContainer
            module="header_scrolling"
            isCerosMobile={true}
            isSponsored={isSponsored}
            social={social}
            articleHed={articleHed}
            category={category} 
            heroImage={heroImage}
            tags={tags}
            hedUrl={hedUrl}
            social={social}
            seo={seo} />
        </div>
      </div>
    </div>
  </div>;
  } else {
    cerosRenderedHeader =
    <div className= {headerClassName}>
    <div className="header-contents">
      <div className="header-content">
        {HeaderMenuButton}
        {HeaderLogo}
        <div className="header-scrolling-article-hed" dangerouslySetInnerHTML={ { __html: articleHed } }></div>
      </div>
      {renderedSponsorLogo}
      <div className={headerContent2ndChildClass}>
        <LinkCopierContainer
          module="header_scrolling"
          isCerosMobile={false}
          isSponsored={isSponsored}
          social={social}
          articleHed={articleHed}
          category={category} 
          heroImage={heroImage}
          tags={tags}
          hedUrl={hedUrl}
          seo={seo} />
      </div>
    </div>
  </div>;
  }

  return (
    <>
      {!isCeros && renderedHeader}
      {isCeros && cerosRenderedHeader}
    </>
  );
};

HeaderCustom.propTypes = {
  HeaderMenuButton: PropTypes.node,
  HeaderLogo: PropTypes.node,
  HeaderLogoMark: PropTypes.node,
  articleHed: PropTypes.string,
};

export default HeaderCustom;
